<div class="section_header">
  <div class="section_header_title">
    <div>
      <h3 class="subtitle">Detalle pedido de publicidad</h3>
      <h2>Campanhas {{model.Campaign}}</h2>
    </div>
    <div class="section_header_buttons">
      <a class="btn-back" (click)="goBack()"><fa-icon [icon]="['fas','chevron-left']"></fa-icon> Voltar</a>
    </div>
  </div>
</div>

<div *ngIf="loadedData==2" [@loadedFadeAnimation]="'visible'" class="mb-5">
  <h3 class="tableTit pb-3">DATOS DEL PEDIDO</h3>
  <div class="row gx-xl-5">
    <div class="col-md-8 col-xl-6 mb-4">
      <table class="features">
        <tr>
          <td>Meio</td>
          <td>{{model.Media}}</td>
        </tr>
        <tr>
          <td>Nº de pedido</td>
          <td>{{model.OrderNumber}}</td>
        </tr>

        <tr *ngFor="let item of formDataValues">
          <td>{{item.LABEL}}</td>
          <td>{{item.VALUE}}</td>
        </tr>
      </table>
    </div>
    <div class="col-md-4 col-xl-6">
      <div class="border">
        <div class="exhibicion__img_content text-center">
          <img [src]="model.FilePreview.FileUri" alt="image" class="w-100" />
        </div>
        <div *ngIf="model.HasLogo && showLogo && model.FileLogo != null" class="exhibicion__img_content text-center">
          <img [src]="model.FileLogo.FileUri" alt="image" class="w-50 mt-2" />
        </div>
      </div>
      <div *ngIf="showLogo && model.FileLogo != null" class="mt-3">
        <a [href]="model.FileLogo.FileUri" class="btn-orange-border btn-icon">
          <div class="svg-icon"><svg viewBox="0 0 150 150">
              <use xlink:href="assets/images/icons/ico_download_auto.svg#img" href="assets/images/icons/ico_download_auto.svg#img"></use>
            </svg>
          </div>
          Descargar logotipo
        </a>
      </div>
    </div>
  </div>
</div>